import { useEffect, useMemo } from 'react';
import { actionButtonOptions } from '../utils/actionButtonOptions';
import { useGetTaskMutation, useGetTaskGroupMutation } from 'store/features/process/processApi';

const useSolutionTaskConfiguration = () => {
	const [getTask, { data: task }] = useGetTaskMutation();
	const [getTaskGroup, { data: taskGroup }] = useGetTaskGroupMutation();

	const taskObjectList = useMemo(() => {
		const taskListObject = {};

		task?.lynTaskDetails?.forEach((item) => {
			taskListObject[item.code] = item;
		});

		return taskListObject;
	}, [task]);

	useEffect(() => {
		getTask({});

		getTaskGroup({});
	}, []);

	return {
		task,
		taskGroup,
		taskObjectList,
		actionButtonOptions,
	};
};

export default useSolutionTaskConfiguration;
